import { Component, AfterViewInit, DoCheck, Input, OnChanges, Output, EventEmitter, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';

import { ShipCaseService } from '../../../service/ship-case/ship-case.service';
import { CarrierService } from '../../../service/carrier/carrier.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';
import { config } from '../../../util/config';

@Component({
  selector: 'wa3041',
  templateUrl: 'wa3041.component.html',
  styleUrls: ['wa3041.component.scss']
})
export class Wa3041Component implements AfterViewInit, DoCheck, OnChanges {
  public componentTitle = 'WA3041:出荷ケース修正';

  public carriers: any;
  public carrierCd: string;
  public shipcaseId: number;
  public carrierTx: string;
  public shiphId: number;
  public ownerCd: string;
  public ownerTx: string;
  public dtaddressCd: string;
  public dtnameTx: string;
  public dtprefTx: string;
  public notinvoiceFl: number;
  public working = false;
  public containerHeight = 500;
  public production = environment.production;
  public backgroundColor: string;
  private errorInfo = '';
  private dspnone: boolean = true;

  readonly STRINGS_ACTIVE = 'active';
  readonly STRINGS_ERROR = 'error';

  @Input() RowData: object[];
  @Input() isShow = false;
  @Output() closeButtonClick = new EventEmitter<boolean>();
  private isDelayHide = true;

  // Define each input element (initial value and validation rule)
  public reqnoCd = new FormControl('', [Validators.maxLength(20), Validators.pattern(/^([0-9])+$/)]);
  public shipcaseNr = new FormControl(0, [Validators.required, Validators.min(1), Validators.max(9999999)]);
  public deliunitpriceNr = new FormControl(0, [Validators.required, Validators.min(0), Validators.max(9999999)]);
  public delipriceNr = new FormControl(0, [Validators.required, Validators.min(0), Validators.max(9999999)]);
  public delichargememoTx = new FormControl('', [Validators.maxLength(50)]);
  // build FormGroup
  myForm = this.builder.group({
    reqnoCd: this.reqnoCd,
    shipcaseNr: this.shipcaseNr,
    deliunitpriceNr: this.deliunitpriceNr,
    delipriceNr: this.delipriceNr,
  });

  private carrierCdCls = '';
  private reqnoCdCls = '';
  private shipcaseNrCls = '';
  private deliunitpriceNrCls = '';
  private delipriceNrCls = '';
  private delichargememoTxCls = '';

  @ViewChild('contentScroll')
  contentScroll: ElementRef;

  constructor(
    private router: Router,
    private builder: FormBuilder,
    private shipCaseService: ShipCaseService,
    private carrierService: CarrierService,
    private commonService: CommonService,
    private dialogsService: DialogsService
  ) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;

    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.onView();
    }, 500);
  }

  ngDoCheck() {
    if (!this.isShow)
      return;

    this.carrierCdCls = this.carrierCd !== '' ? this.carrierCd === this.RowData['carrierCd'] ? '' : this.STRINGS_ACTIVE : this.STRINGS_ERROR;
    this.reqnoCdCls = this.reqnoCd.value === this.RowData['reqnoCd'] ? '' : this.reqnoCd.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR;
    this.shipcaseNrCls = this.shipcaseNr.value == this.RowData['shipcaseNr'] ? '' : this.shipcaseNr.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR;
    this.deliunitpriceNrCls = this.deliunitpriceNr.value == this.RowData['deliunitpriceNr'] ? '' : this.deliunitpriceNr.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR;
    this.delipriceNrCls = this.delipriceNr.value == this.RowData['delipriceNr'] ? '' : this.delipriceNr.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR;
    this.delichargememoTxCls = this.delichargememoTx.value === this.RowData['delichargememoTx'] ? '' : this.delichargememoTx.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR;

    this.checkSubmitButtonState();
  }
  checkSubmitButtonState() {
    if (
      this.carrierCdCls !== this.STRINGS_ERROR &&
      this.reqnoCdCls !== this.STRINGS_ERROR &&
      this.shipcaseNrCls !== this.STRINGS_ERROR &&
      this.deliunitpriceNrCls !== this.STRINGS_ERROR &&
      this.delipriceNrCls !== this.STRINGS_ERROR &&
      this.delichargememoTxCls !== this.STRINGS_ERROR) {
      this.working =
        this.notinvoiceFl != this.RowData['notinvoiceFl'] ||
        this.carrierCdCls === this.STRINGS_ACTIVE ||
        this.reqnoCdCls === this.STRINGS_ACTIVE ||
        this.shipcaseNrCls === this.STRINGS_ACTIVE ||
        this.deliunitpriceNrCls === this.STRINGS_ACTIVE ||
        this.delipriceNrCls === this.STRINGS_ACTIVE ||
        this.delichargememoTxCls === this.STRINGS_ACTIVE;
    } else {
      this.working = false;
    }
  }

  // if (this.RowData !== undefined) {
  //   if (
  //     this.carrierCd !== this.RowData['carrierCd'] ||
  //     this.reqnoCd.value !== this.RowData['reqnoCd'] ||
  //     this.shipcaseNr.value !== this.RowData['shipcaseNr'] ||
  //     this.deliunitpriceNr.value !== this.RowData['deliunitpriceNr'] ||
  //     this.delipriceNr.value !== this.RowData['delipriceNr'] ||
  //     this.notinvoiceFl !== this.RowData['notinvoiceFl'] ||
  //     this.delichargememoTx.value !== this.RowData['delichargememoTx']
  //   ) {
  //     this.working = true;
  //   } else {
  //     this.working = false;
  //   }
  // }


  ngOnChanges() {

    if (this.isShow) {
      this.isDelayHide = false;
      this.initDatas();
    }
    else {
      setTimeout(() => {
        this.isDelayHide = true;
      }, 300);
    }
  }

  initDatas() {
    const shipCase: object = this.RowData;

    this.shipcaseId = shipCase['shipcaseId'];
    this.carrierCd = shipCase['carrierCd'];
    this.carrierTx = shipCase['carrierTx'];
    this.reqnoCd.setValue(shipCase['reqnoCd']);
    this.shipcaseNr.setValue(shipCase['shipcaseNr']);
    this.shiphId = shipCase['shiphId'];
    this.ownerCd = shipCase['ownerCd'];
    this.ownerTx = shipCase['ownerTx'];
    this.dtaddressCd = shipCase['dtaddressCd'];
    this.dtnameTx = shipCase['dtnameTx'];
    this.dtprefTx = shipCase['dtprefTx'];
    this.deliunitpriceNr.setValue(shipCase['deliunitpriceNr']);
    this.delipriceNr.setValue(shipCase['delipriceNr']);
    this.notinvoiceFl = shipCase['notinvoiceFl'];
    this.delichargememoTx.setValue(shipCase['delichargememoTx']);

    setTimeout(() => {
      this.contentScroll.nativeElement.scrollTop = 0;
    }, 100);
  }

  onView() {
    this.carrierService
      .get()
      .then(outputJson => {
        this.carriers = outputJson.carriers;
      })
      .catch(error => {
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
  }

  changeDeliPriceNr(event) {
    if (this.shipcaseNr.value !== undefined && this.deliunitpriceNr.value !== undefined) {
      this.delipriceNr.setValue(this.shipcaseNr.value * this.deliunitpriceNr.value);
    }
  }

  execute() {
    this.working = false;
    this.shipCaseService
      .put(
        this.shipcaseId,
        this.shipcaseNr.value,
        this.carrierCd,
        this.reqnoCd.value,
        this.deliunitpriceNr.value,
        this.delipriceNr.value,
        this.delichargememoTx.value,
        0,
        this.notinvoiceFl,
        'wa3041'
      )
      .then(outputJson => {
        this.cancel();
        this.closeButtonClick.emit(true);
      })
      .catch(error => {
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  cancel() {
    this.errorInfo = '';
    this.closeButtonClick.emit(false);
  }

}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa3Shipment/wa3041/wa3041.component.ts